export interface PostHogIdentity {
  distinct_id: string;
  group_key: string;
  region: string;
  is_org_member_viewer?: boolean;
}

interface JwtPayload {
  exp?: number;
  oneplace?: {
    region?: string;
    metadata?: {
      posthog_distinct_id?: string;
      posthog_group_key?: string;
      is_org_member_viewer?: boolean;
    };
  };
}

function decodeJwtPayload(jwt: string): JwtPayload {
  try {
    return JSON.parse(atob(jwt.split('.')[1])) as JwtPayload;
  } catch {
    return {};
  }
}

export class TokenStore {
  private _jwt: string;
  private _expiresAt: Date;
  private _posthog: PostHogIdentity | undefined;

  constructor(jwt: string) {
    this._jwt = jwt;

    const payload = decodeJwtPayload(jwt);
    this._expiresAt = expiresAtFromPayload(payload);
    this._posthog = posthogFromPayload(payload);
  }

  get jwt(): string {
    return this._jwt;
  }

  get expiresAt(): Date {
    return this._expiresAt;
  }

  get posthog(): PostHogIdentity | undefined {
    return this._posthog;
  }

  update(jwt: string): void {
    this._jwt = jwt;

    const payload = decodeJwtPayload(jwt);
    this._expiresAt = expiresAtFromPayload(payload);
    this._posthog = posthogFromPayload(payload);
  }
}

function expiresAtFromPayload(payload: JwtPayload): Date {
  if (payload.exp) {
    return new Date(payload.exp * 1000);
  }
  return new Date(0);
}

function posthogFromPayload(payload: JwtPayload): PostHogIdentity | undefined {
  const region = payload.oneplace?.region;

  const metadata = payload.oneplace?.metadata;
  if (
    !metadata?.posthog_distinct_id ||
    !metadata?.posthog_group_key ||
    !region
  ) {
    return undefined;
  }

  return {
    region,
    distinct_id: metadata.posthog_distinct_id,
    group_key: metadata.posthog_group_key,
    is_org_member_viewer: metadata.is_org_member_viewer,
  };
}
